module.exports = __webpack_public_path__ + "assets/img/private.76406ec2.jpg";